var DataStore = require('../store');
var store = DataStore.default





const Logarithmic = (id, textx)=>{
    Highcharts.chart(id, {

        title: {
            text: textx
        },
    
        xAxis: {
            tickInterval: 1,
            type: 'logarithmic',
            accessibility: {
                rangeDescription: 'Range: 1 to 10'
            }
        },
    
        yAxis: {
            type: 'logarithmic',
            minorTickInterval: 0.1,
            accessibility: {
                rangeDescription: 'Range: 0.1 to 1000'
            }
        },
    
        tooltip: {
            headerFormat: '<b>{series.name}</b><br />',
            pointFormat: 'x = {point.x}, y = {point.y}'
        },
    
        series: [{
            data: [1, 2, 4, 8, 16, 32, 64, 128, 256, 512],
            pointStart: 1
        }]
    });
}

const BarRace = (id, textx, pria, wanita, kategori, dataPria, dataWanita)=>{


    var categories = kategori;
    
    Highcharts.chart(id, {
        chart: {
            type: 'bar'
        },
        title: {
            text: textx,
            align: 'left'
        },
        subtitle: {
            text: 'Sumber : Dinas Kependudukan dan pencatatan sipil Kab. Konsel',
            align: 'left'
        },
        accessibility: {
            point: {
                valueDescriptionFormat: '{index}. Age {xDescription}, {value}.'
            }
        },
        xAxis: [{
            categories: categories,
            reversed: false,
            labels: {
                step: 1
            },
            accessibility: {
                description: pria
            }
        }, { // mirror axis on right side
            opposite: true,
            reversed: false,
            categories: categories,
            linkedTo: 0,
            labels: {
                step: 1
            },
            accessibility: {
                description: wanita
            }
        }],
        yAxis: {
            title: {
                text: null
            },
            labels: {
                formatter: function () {
                    return Math.abs(this.value) + '';
                }
            },
            accessibility: {
                description: 'Percentage population',
                rangeDescription: 'Range: 0 to 5'
            }
        },
    
        plotOptions: {
            series: {
                stacking: 'normal'
            }
        },
    
        tooltip: {
            formatter: function () {
                return '<b>' + this.series.name + ', age ' + this.point.category + '</b><br/>' +
                    'Population: ' + Highcharts.numberFormat(Math.abs(this.point.y), 1) + '';
            }
        },
    
        series: [{
            name: pria,
            data: dataPria
        }, {
            name: wanita,
            data: dataWanita
        }]
    });
    
}

const PieChart = (id, text, data)=>{
    Highcharts.chart(id, {
        chart: {
            plotBackgroundColor: null,
            plotBorderWidth: null,
            plotShadow: false,
            type: 'pie'
        },
        title: {
            text: text,
            align: 'left'
        },
        tooltip: {
            pointFormat: '{series.name}: <b>{point.percentage:.1f}%</b>'
        },
        accessibility: {
            point: {
                valueSuffix: '%'
            }
        },
        plotOptions: {
            pie: {
                allowPointSelect: true,
                cursor: 'pointer',
                dataLabels: {
                    enabled: true,
                    format: '<b>{point.name}</b>: {point.percentage:.1f} %',
                    connectorColor: 'silver'
                }
            }
        },
        series: [{
            name: 'Share',
            data: data
        }]
    });
}


const BarChart3D = (id, text, kategori, data, titleText)=>{
    Highcharts.chart(id, {
        chart: {
            type: 'column',
            options3d: {
                enabled: true,
                alpha: 10,
                beta: 25,
                depth: 70
            }
        },
        title: {
            text: text,
            align: 'left'
        },
        subtitle: {
            text: 'Sumber: Dinas Kependudukan dan Pencatatan Sipil',
            align: 'left'
        },
        plotOptions: {
            column: {
                depth: 25
            }
        },
        xAxis: {
            categories: kategori,
            labels: {
                skew3d: true,
                style: {
                    fontSize: '16px'
                }
            }
        },
        yAxis: {
            title: {
                text: titleText,
                margin: 20
            }
        },
        tooltip: {
            valueSuffix: ' Jiwa'
        },
        series: [{
            name: 'Jumlah',
            data: data
        }]
    });
}

const getData = async(jmlDukungan_Kec)=>{

    return new Promise ((resolve, reject)=>{
        
        fetch(store.state.url.URL_STATISTIK_KECAMATAN + jmlDukungan_Kec, {
            method: "GET",
            headers: {
              "content-type": "application/json",
              authorization: "kikensbatara " + localStorage.token
            }
        }).then(res => res.json()).then(res_data => {
            resolve (res_data)
        });
    })



}



const postData = async(route, body)=>{

    return new Promise ((resolve, reject)=>{
        
        fetch(store.state.url.URL_DASHBOARD + route, {
            method: "POST",
            headers: {
              "content-type": "application/json",
              authorization: "kikensbatara " + localStorage.token
            },
            body: JSON.stringify(body)
        }).then(res => res.json()).then(res_data => {
            // console.log(res_data)
            resolve (res_data);
        });
    })



}

const postDataPublish = async(route, body)=>{

    return new Promise ((resolve, reject)=>{
        
        fetch(store.state.url.URL_KECAMATAN_PUBLISH + route, {
            method: "POST",
            headers: {
              "content-type": "application/json",
              authorization: "kikensbatara " + localStorage.token
            },
            body: JSON.stringify(body)
        }).then(res => res.json()).then(res_data => {
            resolve (res_data);
        });
    })



}





const persentase = (datakecil, databesar)=>{
    if (databesar <= 0 || datakecil <= 0) {
        return 0
    } else {
        var nilai = datakecil * 100 / databesar
        return nilai.toFixed(3);
    }
}


module.exports = {

    Logarithmic : Logarithmic,
    BarRace : BarRace,
    getData : getData,
    persentase : persentase,
    postData : postData,
    postDataPublish : postDataPublish,
    PieChart : PieChart,
    BarChart3D : BarChart3D
}



